import { FormattedMessage } from 'react-intl';

export const submitSurveyMessages = {
  'submitSurvey.unexpctedError': (
    <FormattedMessage
      id="submitSurvey.unexpctedError"
      defaultMessage="Error submitting your survey. Please try again or contact support."
    />
  ),
};
